export default "__VITE_ASSET__5thDMr5p__"